<template>

</template>



<script >

import { mapState } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  data: function() {
    return {
      sharing: false,
      showDialIn: false,
      showSettings: false,
      showShareScreen: false,
    }
  },

  props: {
  },
  computed: {
    ...mapState([
      'deviceId',
      'device', 
      'conferences',
      'isDevelopment',
      'number',
      'user',
      'userId'
    ]),
    activeConferenceId: {
      get: function() { 
        if (this.state == 'Established') {
          return this.$store.state.conference.activeConferenceId; 
        }
        return null;
      },
      set: function(id) {
        console.log('setting conference id to ' + id);
        this.$store.commit('conference/activeConferenceId', id);
      }
    },
    activeBridge: {
      get: function() { 
        if (this.state == 'Established') {
          return this.$store.state.conference.bridge; 
        }
        return [];
      },
      set: function(bridge) {
        this.$store.commit('conference/bridge', bridge);
      }
    },
    activeSpeakerChannelId: {
      get: function() { 
        if (this.state == 'Established') {
          return this.$store.state.conference.activeSpeakerChannelId; 
        }
        return null;
      },
      set: function(id) {
        console.log('setting conference id to ' + id);
        this.$store.commit('conference/activeSpeakerChannelId', id);
      }
    },
    pinPassword: {
      get: function() {
        console.log('getting pin Password');
        return this.$store.state.conference.pinPassword;
      },
      set: function(val) {
        this.$store.commit('conference/pinPassword', val);
      }
    },
    conf: {
        get: function() { 
          console.log(this.$store);
          //return this.$store.getters['conference/currentConference']; 
          return this.$store.state.conference.conference;
        },
        set: function(c) {
          this.$store.commit('conference/conference',c);
        }
      },
      isActive: function () {
        return (this.activeConferenceId && (this.conf.conference_id == this.activeConferenceId));
      },
      activeParticipants: function() {
        let total = 0;
        if (this.isActive) {
          for (let i=0;i<this.channels.length;i++) {
            let channel = this.channels[i];
            if (channel.state == 'Up') {
              total++;
            }
          }
        }
        return total;
      },
      isGuest: function() {
        if ((!this.user) || (this.user.user_id == 'guest')) {
          return true;
        }
        return false;
      },
      requiresPin: function() {
        console.log('requirePin?')
        if (this.$route.params.confId) {
          console.log('confId');
          if (this.conf.pins) {
            console.log(this.conf.pins);
            for (let i=0;i<this.conf.pins.length;i++) {
              let pin = this.conf.pins[i];
              if (pin.url_token == this.$route.params.confId) {
                if (pin.require_pin_as_password) {
                  if (!pin.pin) {
                    return true;
                  }
                }
              }
            }
          }
        }
        console.log('no');
        return false;
      },
    channels: {
      get: function() { 
        if (this.state == 'Established') {
          return this.$store.state.conference.channels; 
        }
        return [];
      },
      set: function(channels) {
        this.$store.commit('conference/channels', channels);
      }
    },
    myChannel: {
      get: function() { 
        return this.$store.getters['conference/myChannel']; 
      },
    },
    myChannelId: {
      get: function() { 
        if (this.state == 'Established') {
          return this.$store.state.conference.myChannelId; 
        }
        return {};
      },
      set: function(id) {
        this.$store.commit('conference/myChannelId', id);
      }
    },
    state: {
      get: function() {
        if (this.session) {
          return this.session.state;
        }
        return null;
      }
    },
    message: function() {
      if (this.session) {
        return this.session.messages[this.session.messages.length -1];
      }
    },
    session: {
      get: function() {
        return this.$store.getters['sip/session'];
      }
    },
  },
  components: {
    
  },
  methods: {
    hangUpStart(participant) {
      participant.confirmHangup=true;
    },
    disconnect: function() {
      this.$sip.bye();
    },
    kickCaller(channel) {
      if ((this.myChannel.admin) || (this.myChannel.id == channel.id)) {
        this.$http.get(
          global.apiurl + "/conference/hangup-caller&" +
            "token=" + encodeURIComponent(this.click2call) +
            "&pin=" + encodeURIComponent(this.conf.conference_id) +
            "&asterisk_channel=" + encodeURIComponent(channel.id)
        ).then(() => {
          // send event to parent to update the conference list
          this.$emit('updateConferences');
        });
      }
    },
    muteCaller(channel) {
      console.log('muteCaller called');
      if ((this.myChannel.admin) || (this.myChannel.id == channel.id)) {
        this.$http.get(
          global.apiurl + "/conference/mute-caller&" +
            "token=" + encodeURIComponent(this.click2call) +
            "&conferenceId=" + encodeURIComponent(this.conf.conference_id) +
            "&asterisk_channel=" + encodeURIComponent(channel.name)
        ).then(() => {
          // send event to parent to update the conference list
          this.$emit('updateConferences');
        });
      }
      console.log('channel.muted = ', channel.muted)
    },
    unmuteCaller(channel) {
      console.log('unmuteCaller called')
      if ((this.myChannel.admin) || (this.myChannel.id == channel.id)) {
        channel.is_muted = 'N';
        this.$http.get(
          global.apiurl + "/conference/unmute-caller&" +
            "token=" + encodeURIComponent(this.click2call) +
            "&conferenceId=" + encodeURIComponent(this.conf.conference_id) +
            "&asterisk_channel=" + encodeURIComponent(channel.name)
        ).then(() => {
          // send event to parent to update the conference list
          this.$emit('updateConferences');
        });
      }
    },
    getJoinInfoWeb: function(conference=null) {
      let str = 
      "https://join.rinble.com/#/" + this.getBestGuestPin(conference) + "<br>" +
      "Password: " + this.password(conference);
      return str;
    },
    connectWithToken: function(token) {
      global.api.userAction('conference_join', this.conf.conference_id, 'webphone');
      this.$sip.dial('CONF_' + token);
    },
    connectWithBestToken: function() {
      this.connectWithToken(this.getBestToken());
    },
    getBestToken: function(conference = null) {
      // if no conference given, assume its the active conference
      if (!conference) conference = this.conf;

      if (conference.conference_id) {
        for (let i=0;i<conference.pins.length;i++) {
          let pin = conference.pins[i];
          if (pin.is_admin == 'Y') {
            if (pin.token) {
              return pin.token;
            }
          }
        }

        // no admin tokens? connect with guest token
        for (let i=0;i<conference.pins.length;i++) {
          let pin = conference.pins[i];
          if (pin.is_admin == 'N') {
            if (pin.token) {
              return pin.token;
            }
          }
        }
      }
    },
    monitorConference: function () {
      //this.$store.dispatch('subscribeToConference');
      console.log('subscribing to conference');
    },
    getBestGuestPin: function(conference=null) {
      // if no conference given, assume its the active conference
      if (!conference) conference = this.conf;

      if (!conference) return null;
      if (!conference.pins) return null;
      for (let i=0;i<conference.pins.length;i++) {
        let pin = conference.pins[i];
        if (pin.is_admin == 'N') {
          if (pin.url_token) {
            return pin.url_token;
          }
        }
      }
    },
    password: function(conference = null) {
      // if no conference given, assume its the active conference
      if (!conference) conference = this.conf;
      
      if (!conference) return null;
      if (!conference) return null;
      for (let i=0;i<conference.pins.length;i++) {
        let pin = conference.pins[i];
        if (pin.is_admin == 'N') {
          if (pin.url_token) {
            if (pin.require_pin_as_password == 'Y') {
              return pin.pin;
            }
          }
        }
      }
      return null;
    },
    raiseHand: function() {
      console.log('raise hand clicked');
      let self = this;
      let sessionMessageOptions = {
            requestDelegate: {
              onAccept: function(v) {
                for (let j=0;j<self.channels.length;j++) {
                  let ch = self.channels[j];
                  if (self.myChannelId == ch.id) {
                    Vue.set(ch, 'handRaised', true);
                  }
                }
              },
              onRedirect: function(v) {console.log(v)},
              onProgress: function(v) {console.log(v)},
              onReject: function(v) {console.log('reject:');console.log(v)},
              onTrying: function(v) {console.log(v)},
            }, 
            requestOptions: {
              extraHeaders: ['X-FOO:bar'],
              body: {
                content: JSON.stringify({
                  type: 'RaiseHand',
                  value: true,
                  channel: this.myChannelId
                }),
              }
            },
      }
      this.session.message( sessionMessageOptions);
    },
    lowerHand: function(channel) {
      if ((channel.id == this.myChannel.id) || this.myChannel.admin) {
        let sessionMessageOptions = {
              requestDelegate: {
                onAccept: function(v) {
                  channel.handRaised = false;
                },
                onRedirect: function(v) {console.log(v)},
                onProgress: function(v) {console.log(v)},
                onReject: function(v) {console.log('reject:');console.log(v)},
                onTrying: function(v) {console.log(v)},
              }, 
              requestOptions: {
                extraHeaders: ['X-FOO:bar'],
                body: {
                  content: JSON.stringify({
                    type: 'RaiseHand',
                    value: false,
                    channel: channel.id
                  }),
                }
              },
        }
        this.session.message( sessionMessageOptions);
      }
    }
  },
  mounted() {
    
  },
});

</script>

